var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg20 = function Svg20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.183 5.833a.65.65 0 0 1 .65-.65h8.334a.65.65 0 1 1 0 1.3H7.403l7.223 7.224a.65.65 0 0 1-.919.92L6.483 7.402v6.764a.65.65 0 1 1-1.3 0V5.833Z",
    fill: "currentColor"
  })));
};

export { Svg20 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjE4MzMzIDUuODMzMzNDNS4xODMzMyA1LjQ3NDM1IDUuNDc0MzUgNS4xODMzMyA1LjgzMzMzIDUuMTgzMzNIMTQuMTY2N0MxNC41MjU3IDUuMTgzMzMgMTQuODE2NyA1LjQ3NDM1IDE0LjgxNjcgNS44MzMzM0MxNC44MTY3IDYuMTkyMzIgMTQuNTI1NyA2LjQ4MzMzIDE0LjE2NjcgNi40ODMzM0g3LjQwMjU3TDE0LjYyNjMgMTMuNzA3QzE0Ljg4MDEgMTMuOTYwOSAxNC44ODAxIDE0LjM3MjQgMTQuNjI2MyAxNC42MjYzQzE0LjM3MjQgMTQuODgwMSAxMy45NjA5IDE0Ljg4MDEgMTMuNzA3IDE0LjYyNjNMNi40ODMzMyA3LjQwMjU3VjE0LjE2NjdDNi40ODMzMyAxNC41MjU3IDYuMTkyMzIgMTQuODE2NyA1LjgzMzMzIDE0LjgxNjdDNS40NzQzNSAxNC44MTY3IDUuMTgzMzMgMTQuNTI1NyA1LjE4MzMzIDE0LjE2NjdWNS44MzMzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";